import React, { createContext, type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./content-block-group.module.scss";

const cx = c.bind(styles);
const rootClassName = "purpur-content-block-group";

export const ContentBlockGroupContext = createContext<{
  negative?: boolean;
  reverse?: boolean;
} | null>(null);

export type ContentBlockGroupProps = Omit<BaseProps, "children"> & {
  children: ReactNode;
  negative?: boolean;
  mediaStartPosition?: "left" | "right";
};

export const ContentBlockGroup = ({
  children,
  className,
  negative,
  mediaStartPosition = "left",
  ...props
}: ContentBlockGroupProps) => {
  const classes = cx([
    rootClassName,
    {
      [`${rootClassName}--negative`]: negative,
    },
    className,
  ]);

  return (
    <div className={classes} {...props}>
      <ContentBlockGroupContext.Provider
        value={{ negative, reverse: mediaStartPosition === "right" }}
      >
        {children}
      </ContentBlockGroupContext.Provider>
    </div>
  );
};

ContentBlockGroup.displayName = "ContentBlockGroup";
